/**
 * Subdomain detection utilities for company-scoped access.
 * 
 * Examples:
 *   sourdoughsy.com            → null (main site)
 *   www.sourdoughsy.com        → null (main site)
 *   testcompany.sourdoughsy.com → "testcompany"
 *   localhost                  → null (dev)
 *   testcompany.localhost      → "testcompany" (dev testing)
 */

const IGNORED_SUBDOMAINS = new Set(['www', 'api', 'mail', 'ftp', 'admin', 'staging']);

export function getSubdomain(): string | null {
  const host = window.location.hostname.toLowerCase();

  // Standard localhost — no subdomain
  if (host === 'localhost' || host === '127.0.0.1') {
    return null;
  }

  // *.localhost for dev testing
  if (host.endsWith('.localhost')) {
    const sub = host.replace('.localhost', '');
    if (sub && !IGNORED_SUBDOMAINS.has(sub)) return sub;
    return null;
  }

  // Production: anything before the root domain
  const parts = host.split('.');
  if (parts.length > 2) {
    const sub = parts[0];
    if (!IGNORED_SUBDOMAINS.has(sub)) return sub;
  }

  return null;
}

export function isSubdomainAccess(): boolean {
  return getSubdomain() !== null;
}
